import { Card, Skeleton } from '@monksflow/monks-ui';

/**
 * Loading placeholder for {@link KnowledgeHubCard}.
 *
 * Mirrors the real card's shell, padding, and layout 1:1 so swapping the
 * skeleton for loaded content produces no layout shift. The outer `Card`
 * reuses the exact class string from `KnowledgeHubCard` minus the interactive
 * hover/focus affordances, which are meaningless on a non-clickable
 * placeholder.
 */
export const KnowledgeHubCardSkeleton = () => (
  <Card
    data-testid="knowledge-hub-card-skeleton"
    className="h-full gap-0 rounded-lg border border-transparent bg-card p-0 shadow-none"
  >
    <div className="flex h-full flex-col items-start justify-between gap-2xl p-section">
      <Skeleton data-testid="skeleton-loader" className="size-13.5 shrink-0 rounded-sm" />

      <div className="flex w-full flex-col items-start gap-md">
        <div className="flex w-full flex-col gap-sm">
          <Skeleton data-testid="skeleton-loader" className="h-6 w-2/3" />
          <Skeleton data-testid="skeleton-loader" className="h-3.5 w-full" />
          <Skeleton data-testid="skeleton-loader" className="h-3.5 w-11/12" />
          <Skeleton data-testid="skeleton-loader" className="h-3.5 w-3/4" />
        </div>
        <Skeleton data-testid="skeleton-loader" className="h-6 w-24 rounded-full" />
      </div>
    </div>
  </Card>
);

KnowledgeHubCardSkeleton.displayName = 'KnowledgeHubCardSkeleton';
